import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";

/**
 * Deletes a Valuation Event
 */
export class DeletePortfolioGridActionHandler extends GridActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workspace: WorkspaceBase) {
    super(injector, workspace, 'buttonDeletePortfolio');
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    const portfolioIds = this.workspace.grid.getFlattenGridDataResultData().filter(item => item.checkbox).map(item => item.Oid);
    if (portfolioIds.length === 0) {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'errorMessageChoosePortfolio');
    }
    else {
      this.eventBus.broadcastEvent('deletePortfolios', portfolioIds);
    }
  }
}
